import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={10.334}
      cy={10}
      r={9}
      fill="white"
      stroke="#BD2120"
      strokeWidth={2}
    />
    <path
      d="M15.4097 8.22486L15.1717 7.64811C15.9879 5.76512 15.9347 5.70914 15.7751 5.54812L14.7321 4.5079L14.6285 4.41825L14.5081 4.41835C14.4437 4.41835 14.2547 4.41835 12.6685 5.15194L12.0847 4.91112C11.3301 3.00293 11.2531 3.00293 11.0291 3.00293H9.56054C9.33935 3.00293 9.25389 3.00293 8.55537 4.91815L7.97432 5.15887C6.90332 4.69687 6.27472 4.45887 6.10527 4.45887H5.96523L4.84521 5.5789C4.67314 5.7539 4.61289 5.81132 5.47666 7.66491L5.23867 8.24031C3.3291 8.99354 3.3291 9.06629 3.3291 9.30291V10.7701C3.3291 11.0011 3.3291 11.0823 5.2457 11.7837L5.48368 12.3577C4.66749 14.2407 4.72206 14.2967 4.88026 14.4577L5.92323 15.4993L6.02684 15.5903H6.14862C6.21161 15.5903 6.3992 15.5903 7.98679 14.8554L8.56922 15.0975C9.32391 17.0029 9.40086 17.0029 9.62909 17.0029H11.0949C11.3203 17.0029 11.4001 17.0029 12.1016 15.0891L12.6854 14.8483C13.7564 15.3103 14.3821 15.5483 14.5516 15.5483H14.6916L15.8227 14.4186C15.9838 14.2533 16.0397 14.196 15.1815 12.3493L15.4182 11.7739C17.3291 11.0123 17.3291 10.9325 17.3291 10.7029V9.23572C17.3291 9.00466 17.3291 8.92352 15.4097 8.22487L15.4097 8.22486ZM10.3292 12.4516C9.67897 12.4531 9.05485 12.196 8.5943 11.7372C8.13375 11.2782 7.87448 10.655 7.8736 10.0048C7.87272 9.35463 8.13035 8.73081 8.58973 8.27066C9.049 7.81051 9.67245 7.55181 10.3226 7.55161C10.9728 7.55132 11.5964 7.80951 12.0561 8.26929C12.5159 8.72916 12.7739 9.35278 12.7736 10.003C12.7724 10.6513 12.5147 11.2729 12.0566 11.7317C11.5986 12.1906 10.9775 12.4494 10.3291 12.4516H10.3292Z"
      fill="black"
    />
    <line
      x1={3.76653}
      y1={2.85779}
      x2={15.915}
      y2={17.3578}
      stroke="#BD2120"
      strokeWidth={2}
    />
  </svg>
);
export default SVGComponent;
